import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const faqs: [string, string][] = [['¿Qué incluye exactamente el pack Música Lista?', 'Los 12 tomos (6 de Primaria + 6 de Secundaria) más los 5 bonos exclusivos, todo en formato digital listo para usar.'], ['¿Para qué edades sirve?', 'Desde primaria (6 años) hasta el final de secundaria (18 años), organizado por nivel.'], ['¿Cómo accedo al material?', 'Recibís el acceso digital de forma inmediata después de tu compra.'], ['¿En qué formato está el contenido?', 'PDF listo para imprimir o proyectar en clase.'], ['¿Tiene garantía?', 'Sí, 7 días de garantía de satisfacción, sin preguntas.'], ['¿Voy a recibir actualizaciones?', 'Sí, acceso a futuras actualizaciones del pack sin costo adicional.']];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-46" data-mp="1vqkla853vw9a">
      <Reveal className="mx-auto max-w-3xl" data-id="element-47" data-mp="1roft7dub37or">
        <div className="mb-12 text-center" data-id="element-48" data-mp="1rph8juicugca">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-49" data-mp="25fkmzzazt5r6">
            BUENO SABERLO
          </p>
          <h2 className="text-3xl font-black text-brand-blue md:text-4xl" data-id="element-50" data-mp="20om20mf27jhl">Preguntas Frecuentes</h2>
        </div>
        <div className="space-y-3" data-id="element-51" data-mp="2fcpco941rjcq">
          {faqs.map(([question, answer], index) => {
          const open = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={question} className="overflow-hidden rounded-2xl border border-brand-blue/[0.06] bg-brand-alt" data-id="element-52" data-mp="2od5ele556ifh" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(open ? null : index)} aria-expanded={open} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left font-bold text-brand-blue focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-orange" data-id="element-53" data-mp="tzvz95px02pb">
                  <span data-id="element-54" data-mp="2z0gltbuj4tu6">{question}</span>
                  {open ? <MinusIcon className="h-5 w-5 shrink-0 text-brand-orange" aria-hidden="true" data-id="element-55" data-mp="3344rtq3ijhdb" /> : <PlusIcon className="h-5 w-5 shrink-0 text-brand-orange" aria-hidden="true" data-id="element-56" data-mp="3826awb0xvgos" />}
                </button>
                <AnimatePresence initial={false} data-id="element-57" data-mp="3hshs2z9mvmdm">
                  {open && <motion.div id={panelId} role="region" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-58" data-mp="3mrcj2ohr8h8t">
                      <p className="px-6 pb-6 leading-relaxed text-brand-gray" data-id="element-59" data-mp="1k2kmd1f7rw34">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </Reveal>
    </section>;
}